import React from 'react'
import {faCheck} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {useDealStateContext} from 'Src/contexts/DealContext'
import {PROGRESS_STATE, useProgressStateContext} from 'Src/contexts/ProgressContext'
import {getBreadcrumbProgressState} from 'Src/utilities/Helpers'

interface ProgressButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  type: string
  name?: string
}

const ProgressButton = ({onClick, type, name = type}: ProgressButtonProps) => {
  const progress = useProgressStateContext()
  const {dealType} = useDealStateContext()
  const progressState = getBreadcrumbProgressState(dealType, progress, type)

  return (
    <button
      tabIndex={0}
      className="breadcrumbs__link tw-flex tw-w-20 tw-flex-col tw-items-center tw-justify-end sm:tw-relative sm:tw-w-full sm:tw-flex-row sm:tw-justify-center"
      onClick={onClick}
      data-testid={`${type}-button`}
    >
      {progressState === PROGRESS_STATE.untouched ? (
        <div
          className="breadcrumbs__pin breadcrumbs__pin--untouched"
          data-testid={`untouched-${type}`}
        />
      ) : null}
      {progressState === PROGRESS_STATE.started ? (
        <div
          className="breadcrumbs__pin breadcrumbs__pin--started"
          data-testid={`started-${type}`}
        />
      ) : null}
      {progressState === PROGRESS_STATE.complete ? (
        <div
          className="breadcrumbs__pin breadcrumbs__pin--completed"
          data-testid={`complete-${type}`}
        >
          <FontAwesomeIcon
            icon={faCheck}
            className="tw-h-2.5 tw-w-2.5 tw-text-brand-breadcrumbs__pin-icon--completed"
          />
        </div>
      ) : null}
      <span className="breadcrumbs__title tw-mt-6 sm:tw-absolute sm:tw--top-3 sm:tw-mt-0">
        {name[0].toUpperCase() + name.slice(1)}
      </span>
    </button>
  )
}

export default ProgressButton
